import AmexMarketingEditorials from './AmexMarketingEditorials';

export default AmexMarketingEditorials;
